(function () {
  "use strict";

  angular
    .module("virtualFairs")
    .controller("VirtualFairMicrositesListController", VirtualFairMicrositesListController);

  VirtualFairMicrositesListController.$inject = ["VirtualFairService", "virtualFairs"];

  function VirtualFairMicrositesListController(VirtualFairService, virtualFairs) {
    var vm = this;

    // vm.platformRentals = null;

    vm.flag = false;
    vm.getByFilter = getByFilter;
    vm.remove = remove;
    vm.sendPassword = sendPassword;
    vm.platformRentals = [];
    vm.virtualFairs = virtualFairs;
    vm.virtualFairSelected = -1;

    /* PAGINATION */
    vm.pageChanged = pageChanged;
    vm.setPage = setPage;
    vm.page = 1;

    activate();

    function setPage(page) {
      vm.currentPage = page;
    }

    function pageChanged(page) {
      vm.page = vm.currentPage;
      vm.getByFilter();
    }

    function activate() {
      vm.setPage(1);
      vm.getByFilter();
      vm.virtualFairs.unshift({id: -1, name: '--- All ---'});
    }

    function getByFilter() {
      vm.flag = false;
      vm.query = {};
      vm.query["page"] = vm.page;
      if(vm.virtualFairSelected > 0) {
        vm.query['virtual_fair_id'] = vm.virtualFairSelected;
      }
      VirtualFairService.getSchoolVisits(vm.query)
        .then(function (response) {
          vm.microsites = response.data.data;
          vm.totalItems = response.data.total;
          if (vm.totalItems > 0) {
            vm.flag = true;
          }
          vm.itemsPerPage = response.data.per_page;
          vm.setPage(response.data.current_page);
        })
        .catch(function (err) { });
    }

    function remove(microsite) {
      alertify
        .confirm("This action is irreversible!")
        .set("labels", {
          ok: "Ok",
          cancel: "Cancelar",
        })
        .set("title", "Do you really want to delete this microsite?")
        .set("onok", function () {
          VirtualFairService.deleteSchoolVisit(microsite.id).then(function () {
            vm.microsites.splice(vm.microsites.indexOf(microsite), 1);
            alertify.notify("Microsite successfull removed", "success", 3);
          });
        })
        .show();
    }

    function sendPassword(platformRentalUser) {
      alertify
        .confirm('Send password for ' + platformRentalUser.name)
        .set('labels', {
          ok: 'Yes',
          cancel: 'No'
        })
        .set('title', 'Send user password')
        .set('onok', function () {
          PlatformRentalService.sendPassword(platformRentalUser.id).then(function () {
            alertify.notify('Platform rental user password successfull sended', 'success', 3);
          });
        })
        .show();
    }

  }
})();
